<ng-container *transloco="let t">

<div class="modal-header">

  <h2>{{ t('portal.tasks.assetVerificationMultipleBorrowers') }}</h2>

  <!-- hack to fool ngbModal autofocus -->
  <input type="text" style="display:none" />

  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
       (click)="activeModal.dismiss('Cross click')">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
  </div>

</div>

<div class="modal-body px-lg-17 py-10">
  <form #borrowerPickerForm="ngForm" class="form" novalidate id="borrowerPickerForm" name="borrowerPickerForm">
    <label class="form-label" for="answer">{{ t('portal.tasks.pickABorrower') }}</label>
    <select class="form-select form-select-solid" data-control="select2" name="borrowerId" [(ngModel)]="selectedBorrowerId"
      #modelValue="ngModel" [required]="true" [ngClass]="{'is-invalid' : modelValue && modelValue.touched && modelValue.invalid}">
      <option value="">{{ t('portal.tasks.selectOne') }}</option>
      @for (item of borrowers; track item.id) {
        <option [ngValue]="item.id">
          {{item.name}}
        </option>
      }
    </select>
    <div class="invalid-feedback">{{ t('portal.tasks.borrowerRequired') }}</div>
  </form>
</div>

<div class="modal-footer flex-center">
  <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss('Close click')">{{ t('portal.tasks.close') }}</button>
  <button type="button" class="btn btn-primary" (click)="onOkClicked()">{{ t('portal.tasks.ok') }}</button>
</div>



</ng-container>
